export default {
    usageManagement: {
        page: {
            title: '系统管理中心',
            description: '管理用户使用量、模型配置、工具配置和 Langfuse Prompt',
        },
        tabs: {
            overview: '会话监控',
            usage: '用户使用量',
            model: '模型配置',
            tool: '工具配置',
            prompt: 'Prompt 管理',
            feedback: 'Feedback 管理',
            payment: '支付统计',
            tokenUsage: 'Token 使用量',
            report: '统计报表',
            userActivityReport: '日活报表',
            assetStats: '资产统计',
            documentStats: '文档统计',
            skill: 'Skill 管理',
            role: '人员管理',
        },
        overview: {
            metrics: {
                totalSessions: '总会话数',
                avgDuration: '平均会话时长',
                avgRounds: '平均对话轮数',
                successRate: '任务成功率',
                activeUsers: '活跃用户数',
            },
            date: { today: '今天', yesterday: '昨天', last3days: '最近3天', last7days: '最近7天' },
            refresh: '刷新',
            table: {
                sessionId: '会话ID', user: '用户', email: '邮箱', ip: '归属地',
                rounds: '对话轮数', duration: '持续时长', successFailure: '成功/失败',
                startTime: '开始时间', copy: '复制', intranet: '内网',
            },
            drawer: {
                title: '会话详情', sessionId: '会话ID', user: '用户', email: '邮箱',
                taskId: '任务ID', status: '状态', ip: 'IP', duration: '耗时', startTime: '开始时间',
            },
            copied: '已复制',
            searchEmail: '搜索用户邮箱',
        },
        usage: {
            config: {
                title: '全局配置', baseTab: '基础配置', visitorLimit: '游客每日限制', accountLimit: '免费用户限制',
                userTaskConcurrencyLimit: '付费用户单用户并发限制',
                globalTaskConcurrencyLimit: '付费用户全局并发限制',
                freeUserTaskConcurrencyLimit: '免费用户单用户并发限制',
                freeGlobalTaskConcurrencyLimit: '免费用户全局并发限制',
                aiCallsPerMinuteLimit: '模型调用每分钟并发限制',
                aiCallsCurrentCount: '当前 AI 调用数（本分钟）',
                aiCallsCurrentCountUnit: '次',
                save: '保存配置', hint: '提示：修改后将应用于所有新用户',
            },
            metrics: {
                totalUsage: '今日总使用', avgUsage: '平均使用次数', avgPerUser: '平均 {n} 次/人',
                activeUsers: '活跃用户数', activeRate: '{n}% 活跃率',
                exceededUsers: '超限用户数', exceededRate: '{n}% 超限率',
            },
            date: { today: '今天', yesterday: '昨天', last3days: '最近3天', last7days: '最近7天', placeholder: '选择日期' },
            toolbar: {
                searchPlaceholder: '搜索用户邮箱', sortField: '排序字段', sortOrder: '排序方向',
                sortByCount: '使用次数', sortByUserId: '用户 ID', sortDesc: '降序', sortAsc: '升序', refresh: '刷新',
            },
            table: {
                title: '用户使用量列表', export: '导出数据', user: '用户', count: '使用次数',
                limit: '限制', usageRate: '使用率', remaining: '剩余', status: '状态', action: '操作',
                copyEmail: '复制邮箱', copyId: '复制 ID', total: '共 {n} 条记录',
                empty: '暂无用户数据', emptyHint: '等待用户开始使用对话功能',
            },
            status: { exceeded: '超限', warning: '接近', normal: '正常' },
            customLimit: {
                tag: '自定义',
                setLimit: '设置限制',
                reset: '恢复默认',
                dialogTitle: '设置用户每日限制',
                user: '用户',
                dailyLimit: '每日限制',
                remark: '备注',
                remarkPlaceholder: '备注（可选）',
                cancel: '取消',
                confirm: '确认',
                setSuccess: '用户限制设置成功',
                setFailed: '设置失败',
                removeSuccess: '已恢复为全局默认限制',
                removeFailed: '操作失败',
            },
            export: {
                account: '账号', userId: '用户ID', company: '公司名称', count: '使用次数',
                limit: '限制', remaining: '剩余', status: '状态',
                success: '导出成功', filename: '用户使用统计_{date}.csv',
            },
            copied: '已复制',
        },
        report: {
            refresh: '刷新',
            timeWindowDefault: '默认 5分钟',
            timeWindow: {
                '5min': '5分钟', '30min': '30分钟', '60min': '60分钟',
                today: '今天', last7days: '近7天', last30days: '近30天',
                last3months: '近3个月', last6months: '近半年', last1year: '近一年',
                minutes: '{n}分钟',
            },
            userStatsTitle: '用户统计',
            taskStatsTitle: '任务统计',
            filters: {
                users: '筛选用户',
                companies: '筛选公司',
                agents: '筛选Agent类型',
                searchUser: '搜索用户邮箱',
                searchCompany: '搜索公司名',
                agentTypes: {
                    disclosure: '交底书',
                    patentDraft: '专利申请',
                    prosecution: '审查意见书',
                },
            },
            userMetrics: {
                dau: '日活用户（DAU）',
                mau: '月活用户（MAU）',
                uv: '独立访客（UV）',
                pv: '页面浏览量（PV）',
                avgDuration: '平均会话时长',
                avgTokensPerMessage: '次均Token数',
            },
            userCharts: {
                tokenTask: 'Token消耗 & 任务数趋势',
                dauMau: 'DAU/MAU 趋势',
                uvPv: 'UV & PV 趋势',
                avgDuration: '平均会话时长趋势',
                avgConversations: '人均对话数趋势',
                avgTokensPerMessage: '次均Token数趋势',
                tokenLabel: 'Token消耗',
                taskLabel: '任务数',
                dauLabel: '日活（DAU）',
                mauLabel: '月活（MAU）',
                uvLabel: '独立访客（UV）',
                pvLabel: '页面浏览量（PV）',
                avgDurationLabel: '平均会话时长',
                avgConversationsLabel: '人均对话数',
                avgTokensPerMessageLabel: '次均Token数',
            },
            metrics: {
                workers: '在线 Worker', activeTasks: '活跃任务',
                successRate: '成功率', totalTasks: '总任务({window})', avgDuration: '平均耗时',
            },
            chart: { title: '任务趋势', empty: '暂无趋势数据', total: '总量', success: '成功', failure: '失败' },
            byType: {
                title: '任务类型分布', type: '类型', total: '总数',
                success: '成功', failure: '失败', successRate: '成功率', avgDuration: '平均耗时',
            },
            activeTasks: {
                title: '当前活跃任务', fallback: '降级模式', empty: '当前无活跃任务',
                worker: 'Worker', taskType: '任务类型', runtime: '运行时长', taskId: '任务ID',
            },
        },
        tokenUsage: {
            title: '用户 Token 使用量列表',
            summary: { users: '用户数', totalTokens: '总 Token', totalMessages: '总消息数', totalTasks: '总任务数', avgTokensPerTask: '平均 Token / 任务' },
            filter: {
                timeWindowPlaceholder: '选择时间窗口', statusPlaceholder: '任务状态',
                statusAll: '全部状态', statusSuccess: '成功', statusFailure: '失败',
                statusStarted: '执行中', statusPending: '等待中',
                searchPlaceholder: '搜索用户邮箱',
                sortByTokens: 'Total Token', sortByMessages: '消息数', sortByTasks: '任务数',
                sortDesc: '降序', sortAsc: '升序', refresh: '刷新',
                expandAll: '展开全部', collapseAll: '折叠全部',
            },
            timeWindow: {
                '5min': '5分钟', '10min': '10分钟', '30min': '30分钟', '1h': '1小时',
                today: '今天', last7days: '最近7天', last30days: '最近30天',
            },
            table: {
                user: '用户', totalTokens: 'Token 用量', messages: '消息数', tasks: '任务数',
                conversations: '会话数', conversation: '会话', convTokens: '会话 Token', status: '状态', ip: 'IP',
                createdAt: '创建时间', empty: '暂无 Token 使用数据',
            },
            pagination: { total: '共 {n} 个用户' },
            copied: '已复制',
        },
        model: {
            agentSection: 'Agent 主模型配置', agentCount: '{n} 个 Agent',
            taskSection: '任务级模型覆盖', taskCount: '{n} 项',
            modelLabel: '模型', modelPlaceholder: '搜索或选择模型',
            tempLabel: '温度 ({val})', tempPlaceholder: '温度', maxTokensPlaceholder: '不限制',
            maxOutput: '最大输出 {n}', maxTemp: '温度上限 {n}',
            multimodal: '多模态', thinking: '推理',
            multimodalSupport: '支持多模态', thinkingSupport: '支持推理',
            taskHeader: { task: '任务', model: '模型', temp: '温度' },
            categories: { drafting: '专利撰写', prosecution: '答复文件', rag: '文档处理', image: '图像分析', general: '通用任务', style: '风格提取' },
            save: '保存配置', undoEdit: '撤销编辑', resetDefault: '恢复默认', unsaved: '有未保存的更改',
            loadFail: '加载模型配置失败', saveSuccess: '模型配置保存成功', saveFail: '保存模型配置失败',
            undoDone: '已撤销未保存的编辑',
            resetConfirmMsg: '将清除所有自定义配置，恢复为系统默认值。此操作不可撤销。',
            resetConfirmTitle: '确认恢复默认', resetConfirmBtn: '恢复默认', resetCancel: '取消',
            resetSuccess: '已恢复为系统默认配置', resetFail: '恢复默认配置失败',
        },
        tool: {
            baseTools: '基础工具（不可配置）', specificTools: '专属工具（可配置）',
            itemCount: '{n} 项', required: '必需', noSpecificTools: '该 Agent 暂无专属工具',
            save: '保存配置', reset: '重置', unsaved: '有未保存的更改',
            loadFail: '加载工具配置失败', saveSuccess: '工具配置保存成功',
            saveFail: '保存工具配置失败', resetDone: '已重置为上次保存的配置',
        },
        proLimit: {
            title: 'Pro 用户文档数量限制',
            patentDraftLimit: '专利撰写限制',
            disclosureLimit: '交底书限制',
            oarLimit: '审查意见限制',
            unit: '篇',
            saveSuccess: 'Pro 文档限制保存成功',
            saveFail: '保存失败',
            loadFail: '加载失败',
        },
        freeLimit: {
            title: 'Free 用户文档数量限制',
            totalDocumentLimit: '文档总量限制',
            patentDraftLimit: '专利撰写限制',
            disclosureLimit: '交底书限制',
            oarLimit: '审查意见限制',
            unit: '篇',
            saveSuccess: 'Free 文档限制保存成功',
            saveFail: '保存失败',
            loadFail: '加载失败',
        },
        prompt: {
            config: {
                title: 'Langfuse 配置',
                publicKeyLabel: 'Public Key', secretKeyLabel: 'Secret Key', hostLabel: 'Host URL（可选）',
                testConnection: '测试连接', loadPrompts: '加载所有 Prompts',
                checkSync: '检查同步状态', batchPush: '批量推送',
                promptNamePlaceholder: '输入 Prompt 名称', fetch: '获取',
                missingKeys: '请输入 Public Key 和 Secret Key',
                connectSuccess: '连接成功！', connectFail: '连接失败: {msg}',
                loadSuccess: '成功加载 {n} 个 Prompts', loadFail: '加载 Prompts 失败: {msg}',
                fetchFail: '获取 Prompt 失败: {msg}', promptNameRequired: '请输入 Prompt 名称',
                connectFirst: '请先测试连接', loadFirst: '请先加载前端 Prompts',
            },
            list: {
                title: 'Prompt 管理', count: '共 {n} 个', searchPlaceholder: '搜索 prompts...',
                loading: '正在加载 Prompts...', empty: '暂无 Prompts 数据', reload: '重新加载',
                colName: '名称', colType: '类型', colLabels: '标签',
                colSyncStatus: '同步状态', colActions: '操作',
                view: '查看', push: '推送', synced: '已同步', unchecked: '未检查',
            },
            sync: {
                same: '已同步', different: '需更新', frontendOnly: '待推送', backendOnly: '仅后端',
                checkDone: '同步状态检查完成！共检查 {total} 个 - 已同步: {same}, 需更新: {diff}, 待推送: {pending}, 仅后端: {backend}',
                checkFail: '检查同步状态失败: {msg}',
            },
            push: {
                dialogTitle: '推送 Prompts 到后端', selected: '共选择 {n} 个需要推送的 Prompts',
                overwrite: '覆盖已存在的 Prompts',
                pushing: '正在分批推送中，每批最多5个 Prompts...',
                cancel: '取消', pushBtn: '推送 ({n})', nothingToPush: '没有需要推送的 Prompts',
                batchInfo: '正在推送第 {cur}/{total} 批 ({n} 个 Prompts)...',
                batchDone: '第 {n} 批推送完成！成功: {success}, 失败: {fail}',
                allDone: '所有批次推送完成！总计 - 成功: {success}, 失败: {fail}, 跳过: {skip}',
                pushFail: '推送失败: {msg}',
                singleSuccess: '{name} 推送成功！', singleSkipped: '{name} 推送被跳过',
                singleFail: '推送 {name} 失败: {msg}',
            },
            detail: {
                name: '名称', type: '类型', version: '版本', labels: '标签',
                content: 'Prompt 内容：', fetchFail: '获取 Prompt 详情失败: {msg}',
            },
        },
        assetStats: {
            totalTemplates: '总模板数',
            totalInstructions: '总指令数',
            totalStyles: '总风格数',
            startDate: '开始日期',
            endDate: '结束日期',
            searchUser: '搜索用户邮箱',
            user: '用户',
            templates: '模板数',
            instructions: '指令数',
            styles: '风格数',
            all: '全部',
            today: '今天',
            yesterday: '昨天',
            last7days: '最近7天',
            last30days: '最近30天',
            refresh: '刷新',
            tableTitle: '资产统计列表',
            empty: '暂无数据',
            copied: '已复制',
            total: '共 {n} 条记录',
        },
        documentStats: {
            docGroup: '文档统计',
            assetGroup: '资产统计',
            totalDocuments: '总文档数',
            totalExports: '总导出次数',
            startDate: '开始日期',
            endDate: '结束日期',
            searchUser: '搜索用户邮箱',
            searchUserBatch: '邮箱或用户ID，多个用逗号分隔',
            user: '用户',
            userId: '用户ID',
            company: '公司',
            email: '邮箱',
            disclosure: '交底书',
            patentDraft: '专利申请',
            prosecution: '审查意见书',
            totalCount: '总文档数',
            exportCount: '导出次数',
            templateCount: '模板数',
            instructionCount: '指令数',
            styleCount: '风格数',
            folderCount: '文件夹数',
            totalTemplates: '总模板数',
            totalInstructions: '总指令数',
            totalStyles: '总风格数',
            totalFolders: '总文件夹数',
            all: '全部',
            today: '今天',
            yesterday: '昨天',
            last7days: '最近7天',
            last30days: '最近30天',
            custom: '自定义',
            refresh: '刷新',
            tableTitle: '资产统计列表',
            empty: '暂无数据',
            copied: '已复制',
            total: '共 {n} 条记录',
            userTypeAll: '全部用户',
            userTypeExternal: '外部用户',
            filterTimeRange: '时间范围',
            filterUser: '用户筛选',
            search: '查询',
            reset: '重置',
            bulkSearch: '批量搜索',
            bulkSearchHint: '每行一个邮箱，或用逗号、空格分隔',
            uploadFile: '上传文件',
            uploadFileHint: '支持 .xlsx / .xls / .csv，第一列为邮箱',
            dropZoneText: '拖拽 Excel / CSV 文件到此处，或点击上传',
            emailInputPlaceholder: '输入邮箱，按回车添加',
            recognizedCount: '已识别 {n} 个邮箱',
            clearAll: '清空',
            cancel: '取消',
            emailCount: '{n} 个邮箱',
            importedCount: '已导入 {n} 个邮箱',
            clearImport: '清除',
            export: '导出',
            exportAll: '导出全部',
            exportSelected: '导出选中',
            selectedCount: '已选 {n} 项',
            exportSuccess: '导出成功',
            parseError: '文件解析失败',
            noEmailFound: '未找到有效邮箱',
        },
        feedback: {
            title: '用户反馈管理',
            totalCount: '共 {n} 条',
            searchEmail: '搜索用户邮箱',
            statusPlaceholder: '状态',
            categoryPlaceholder: '分类',
            priorityPlaceholder: '优先级',
            refresh: '刷新',
            emptyText: '暂无反馈数据',
            colUser: '用户',
            colTitle: '标题',
            colCategory: '分类',
            colStatus: '状态',
            colPriority: '优先级',
            colTime: '提交时间',
            copyEmail: '复制邮箱',
            copyId: '复制 ID',
            copyProjectId: '复制 Project ID',
            copied: '已复制',
            paginationTotal: '共 {n} 条',
            status: {
                pending: '待处理',
                processing: '处理中',
                resolved: '已解决',
                closed: '已关闭',
            },
            category: {
                bug: '缺陷',
                suggestion: '建议',
                feature_request: '功能请求',
                other: '其它',
            },
            priority: {
                high: '高',
                medium: '中',
                low: '低',
            },
            drawer: {
                statusLabel: '状态',
                priorityLabel: '优先级',
                statusPending: '待处理',
                statusProcessing: '处理中',
                statusResolved: '已解决',
                statusClosed: '已关闭',
                priorityHigh: '高',
                priorityMedium: '中',
                priorityLow: '低',
                adopt: '采纳',
                noMessages: '暂无消息记录',
                replyPlaceholder: '输入回复内容，Enter 换行，Ctrl+Enter 发送...',
                replyHint: 'Ctrl+Enter 快速发送',
                sendReply: '发送回复',
                statusLabelPending: '待处理',
                statusLabelProcessing: '处理中',
                statusLabelResolved: '已解决',
                statusLabelClosed: '已关闭',
                categoryBug: '缺陷',
                categorySuggestion: '建议',
                categoryFeatureRequest: '功能请求',
                categoryOther: '其它',
                priorityHighLabel: '高优先级',
                priorityMediumLabel: '中优先级',
                priorityLowLabel: '低优先级',
            },
        },
        modelConfig: {
            groupLabel: '配置组',
            activeTag: '激活',
            create: '新建',
            rename: '重命名',
            delete: '删除',
            createDialogTitle: '新建配置组',
            nameLabel: '名称',
            namePlaceholder: '如 GPT优先、经济模式',
            copyFromLabel: '复制自',
            copyFromPlaceholder: '不复制（空配置）',
            cancel: '取消',
            createBtn: '创建',
            renameDialogTitle: '重命名配置组',
            renamePlaceholder: '新名称',
            save: '保存',
            switchSuccess: '已切换配置组',
            switchFail: '切换配置组失败',
            nameRequired: '请输入配置组名称',
            createSuccess: '配置组创建成功',
            createFail: '创建失败',
            updateSuccess: '配置组已更新',
            updateFail: '更新失败',
            deleteConfirmMsg: '确定删除配置组「{name}」？此操作不可撤销。',
            deleteConfirmTitle: '删除配置组',
            deleteConfirmBtn: '删除',
            deleteSuccess: '配置组已删除',
            deleteFail: '删除失败',
        },
        langfuse: {
            connectionFallback: '连接失败',
            connectionFailMsg: '连接失败: {msg}',
            connectFirst: '请先测试连接',
            promptNameRequired: '请输入 Prompt 名称',
        },
        payment: {
            totalCount: '总笔数',
            totalAmount: '总金额 (USD)',
            records: '支付记录',
            total: '共 {n} 条',
            searchPlaceholder: '搜索邮箱/套餐',
            startDate: '开始日期',
            endDate: '结束日期',
            refresh: '刷新',
            emptyText: '暂无支付记录',
            user: '用户',
            plan: '套餐',
            amount: '金额',
            cycle: '周期',
            time: '时间',
            monthly: '月付',
            yearly: '年付',
            loadFailed: '加载支付记录失败',
            statsFailed: '加载统计失败',
        },
        skill: {
            patentOffice: '受理局',
            mode: '模式',
            modeAgent: '完整模式',
            modeCopilot: '轻量模式',
            disclosure: '交底书',
            patentDraft: '专利申请',
            prosecution: '审查意见答复',
            empty: '暂无数据',
            loadFailed: '加载失败',
            save: '保存',
            reset: '重置',
            saveSuccess: '保存成功',
            saveFailed: '保存失败',
            editor: { edit: '编辑', split: '分屏', preview: '预览' },
        },
        role: {
            searchPlaceholder: '搜索邮箱',
            search: '搜索',
            assign: '分配角色',
            email: '邮箱',
            role: '角色',
            assignedBy: '分配人',
            remark: '备注',
            createdAt: '创建时间',
            action: '操作',
            remove: '移除',
            assignTitle: '分配角色',
            cancel: '取消',
            confirm: '确认',
        },
        userDetail: {
            title: '用户详情',
            userId: '用户 ID',
            company: '公司',
            sectionDocStats: '文档统计',
            sectionTokenUsage: 'Token 用量',
            sectionSessions: '会话记录',
            sectionUsageLimits: '用量限额',
            disclosure: 'Disclosure',
            patentDraft: 'Patent Draft',
            prosecution: 'Prosecution',
            totalDocs: '文档总数',
            exports: '导出',
            templates: '模板',
            instructions: '指令',
            styles: '风格',
            folders: '文件夹',
            totalTokens: 'Token 总量',
            totalMessages: '消息总数',
            taskCount: '任务数',
            conversationId: '会话',
            tokens: 'Tokens',
            messages: '消息',
            rounds: '轮次',
            duration: '时长',
            successFailure: '成功 / 失败',
            startTime: '开始时间',
            chatCount: '对话次数',
            limit: '限额',
            customLimit: '自定义限额',
            remaining: '剩余',
            exceeded: '已超限',
            normal: '正常',
            noData: '暂无数据',
            copied: '已复制',
        },
    },
};
